
import { createApiSlice } from "@common/common-slice/commonSlice";


// ---------------------------------------------------------------------

const apiConfig = [
];

const customReducers = {
  initialState: {
    loading: false,
    generate: false,
    assessmentTemplateData: [],
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "assessmentTemplate",
  apiConfig,
  customReducers,
);

const prepareAssessmentSlice = slice;

export default prepareAssessmentSlice.reducer;

export const {
  rowSelect,
} = actions;